import { render, staticRenderFns } from "./integrateManagementDetail.vue?vue&type=template&id=178396a8&scoped=true&"
import script from "./integrateManagementDetail.vue?vue&type=script&lang=js&"
export * from "./integrateManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./integrateManagementDetail.vue?vue&type=style&index=0&id=178396a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178396a8",
  null
  
)

export default component.exports